import React from "react";

import { Avatar, AvatarImage, Button, Col, Form, Row, TextArea } from "components";

export const CommentInputPanel = ({ buttonText, formRef, image, label, name, onFinish, onFinishFailed, loading, sticky, userName, required = true }) => (
  <Form ref={formRef} name="respond" onFinish={(v) => onFinish(v)} onFinishFailed={(v) => onFinishFailed(v)}>
    <Row>
      <Col>
        <div className="inline comment-input-panel-input">
          {image ? <AvatarImage image={image} /> : <Avatar name={userName} />}
          <TextArea className="small margin-left-100" autoSize={true} label={label} name={name} rules={[{ required: required }]} />
        </div>
      </Col>
    </Row>
    <Row>
      <Col>
        <div className={`comment-input-panel-button float-right ${sticky ? "sticky" : ""}`}>
          <Button type="primary" htmlType="submit" disabled={loading} loading={loading} style={{ width: "auto" }}>
            {buttonText}
          </Button>
        </div>
      </Col>
    </Row>
  </Form>
);
